<div class="error-container">
	<div class="error-card">
		<h1>Authentication Error</h1>
		<p>Your session has expired or you do not have permission to access this page.</p>

		<button (click)="reloadPage()" class="reload-btn">
			Reload Application
		</button>
	</div>
</div>